import { LANG_ES } from "@/constants/Language";

const getHasSpanishLanguageLevel = (articleLevels) => {
  // Find if there is a spanish version
  return !!articleLevels.find((level) => level.language === LANG_ES);
};

export default getHasSpanishLanguageLevel;
